(() => {
  if (window.__hiknightClickDropdownReady) return;
  window.__hiknightClickDropdownReady = true;

  const selector = 'summary[data-hiknight-click-opens-menu="true"]';
  const desktop = () => window.matchMedia('(min-width: 1024px)').matches;

  document.addEventListener('click', (event) => {
    const summary = event.target instanceof Element ? event.target.closest(selector) : null;
    if (!summary || !desktop()) return;

    const targetUrl = summary.dataset.link;
    if (!targetUrl || targetUrl === '#') return;

    /*
      Desktop behavior:
      - Hover is still handled by the theme's <details trigger="hover"> logic.
      - A real click on Electric Bike should navigate to its collection page.

      Previous versions intercepted the click to toggle <details>, which made the
      navigation item stop opening its destination page.
    */
    event.preventDefault();
    event.stopImmediatePropagation();

    if (event.metaKey || event.ctrlKey) {
      window.open(targetUrl, '_blank', 'noopener');
      return;
    }

    window.location.assign(targetUrl);
  }, true);
})();
 